import React, {useEffect} from 'react';
import {useI18nContext} from "../../contexts/I18nContext";
import {useStyles} from "./ArticleWarehouses.style";
import Box from "../../ui_components/Box/Box";
import Width from "../../ui_components/common/enums/Width";
import Alignment from "../../ui_components/common/enums/Alignment";
import FilterInput from "../../shared_components/Inputs/FilterInput/FilterInput";
import Button from "../../ui_components/Button/Button";
import {Observer} from "mobx-react-lite";
import ShowPagination from "../../ui_components/ShowPagination/ShowPagination";
import MessageCard from "../../ui_components/MessageCard/MessageCard";
import AccountBoxSharpIcon from '@mui/icons-material/AccountBoxSharp';
import ArticleWarehouseRow from "./ArticleWarehouseRow/ArticleWarehouseRow";
import ArticleWarehouseStore from "./ArticleWarehouseStore";
import {useCommonContext} from "../../contexts/CommonContext";
import useOnEnterPress from '../../hooks/EnterPress';
import NewArticleWarehouseButton from '../../shared_components/Buttons/NewArticleWarehouseButton/NewArticleWarehouseButton';
import ButtonType from '../../ui_components/Button/ButtonType';

const ArticleWarehouses: React.FC = () => {
    const commonStore = useCommonContext();
    const i18n = useI18nContext();
    const articleWarehouseStore = new ArticleWarehouseStore(commonStore);
    const classes = useStyles();

    useEffect(() => {
        articleWarehouseStore.getElements();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onUpdate = async () => {
        await articleWarehouseStore.getElements();
    }

    const onPaginationChange = async (page: number, pageSize: number) => {
        await articleWarehouseStore.goToPage(page, pageSize);
    }

    const onArticleWarehouseSearch = () => {
        articleWarehouseStore.search()
    }
    useOnEnterPress(onArticleWarehouseSearch,[articleWarehouseStore]);

    return (
        <Observer>
            {() => (
                <div className={classes.article_warehouses_container}>
                    <Box className={classes.tools_container}
                         width={Width.FULL_WIDTH}
                         justifyContent={Alignment.END}
                    >
                        <></>
                        <>
                            <NewArticleWarehouseButton type={ButtonType.SECONDARY} onSave={onUpdate}/>
                        </>
                    </Box>
                    <Box className={classes.filter_container} width={Width.FULL_WIDTH}
                         justifyContent={Alignment.SPACE_BETWEEN}>
                        <FilterInput value={articleWarehouseStore.filter}
                                     placeholder={'Nombre'}
                                     onChange={(value) => {
                                         articleWarehouseStore.setFilter(value)
                                     }} onEnter={() => articleWarehouseStore.search()}/>
                        <Button
                            onClick={onArticleWarehouseSearch}
                            className={classes.search_btn}
                            text={i18n.translate("SEARCH")}
                        />
                    </Box>
                    {!articleWarehouseStore.isEmpty &&
                    <div className={classes.article_warehouses_table}>
                        <ShowPagination onChange={onPaginationChange}
                                        elementLabel={'Almacenes'}
                                        pagination={articleWarehouseStore.pagination}/>
                        <div className={classes.elements_container}>
                            {articleWarehouseStore.articleWarehouses.map((articleWarehouse, i) => (
                                <ArticleWarehouseRow
                                    onUpdate={onUpdate}
                                    articleWarehouse={articleWarehouse}
                                    key={i}
                                />
                            ))}
                        </div>
                        <ShowPagination
                            onChange={onPaginationChange}
                            elementLabel={'Almacenes'}
                            pagination={articleWarehouseStore.pagination}/>
                    </div>}
                    {articleWarehouseStore.isEmpty &&
                    <MessageCard icon={AccountBoxSharpIcon} title={i18n.translate("NO_ARTICLE_WAREHOUSES_TITLE")}
                                 subtitle={i18n.translate("NO_CLIENTS_SUBTITLE")}/>}
                </div>
            )}
        </Observer>
    )
}

export default ArticleWarehouses;
